// Payroll (Salaires & Bonus) — shared types + constants.
// Ported from the validated prototype in design/salaires-bonus/.
// Seul VIREMENT part dans le fichier banque ; les autres sont payés à la
// main et listés « hors fichier » dans l'export.
export const PAYMENT_METHODS = {
    VIREMENT: { label: 'Virement' },
    CHEQUE: { label: 'Chèque' },
    A_PART: { label: 'Payé à part' },
};
export const PAYMENT_METHOD_KEYS = Object.keys(PAYMENT_METHODS);
// ─── Note tags ───────────────────────────────────────────────
export const PAYROLL_TAGS = {
    perf: { label: 'Perf' },
    projet: { label: 'Projet' },
    client: { label: 'Client' },
    retard: { label: 'Retards' },
    augm: { label: 'Augmentation ?' },
};
export const PAYROLL_TAG_KEYS = Object.keys(PAYROLL_TAGS);
// ─── Bank file (DEFAULT BANK TEMPLATE) ───────────────────────
// Column headers reproduced verbatim — the bank matches on them.
// Note the trailing space in "Référence Du Donneur D'ordre ".
export const BANK_TEMPLATE_COLUMNS = [
    "Numéro Du Compte Donneur D'ordre",
    "Code Swift De La Banque Donneuse D'ordre",
    'Nom De La Contrepartie',
    'Numéro De Compte De La Contrepartie',
    'Pays Ou Emplacement De La Contrepartie',
    'Code Swift De La Banque De La Contrepartie',
    'Pays Ou Emplacement De La Banque De La Contrepartie',
    'Charges',
    "Devise De L'instruction",
    "Montant De L'instruction",
    "Référence Du Donneur D'ordre ",
    'Référence De La Contrepartie',
];
// ─── Payeurs (donneurs d'ordre) ──────────────────────────────
// Trois comptes bancaires émetteurs pour quatre entités : SHIFT GROUP
// Alger et Annaba sont une seule société et paient depuis le même
// compte. Le compte payeur est estampillé sur CHAQUE ligne du fichier,
// donc un fichier ne peut porter qu'un seul payeur : l'export produit
// trois fichiers, jamais un seul « toutes entités ».
export const PAYROLL_PAYERS = [
    { id: 'shiftin', label: 'SHIFTIN', entityIds: ['shiftin'] },
    { id: 'octera', label: 'Octera', entityIds: ['octera'] },
    { id: 'shiftgroup', label: 'SHIFT GROUP', entityIds: ['shiftgrp_alger', 'shiftgrp_annaba'] },
];
export const PAYROLL_PAYER_IDS = PAYROLL_PAYERS.map((p) => p.id);
export function payerOfEntity(entityId) {
    const hit = PAYROLL_PAYERS.find((p) => p.entityIds.includes(entityId));
    return hit ? hit.id : null;
}
export function payerLabel(id) {
    return PAYROLL_PAYERS.find((p) => p.id === id).label;
}
// ─── Faits du mois (grille mensuelle validée) ────────────────
// Règle Chouaib (oct. 2026) : chaque jour ouvré non travaillé retire
// 1/22 du salaire de référence. Retirés : maladie, absences justifiées
// ou non, jours avant l'entrée / après la sortie. Payés : présence,
// congé, récup, télétravail, fériés. Le diviseur est fixe — un mois de
// 21 ou 23 jours ouvrés entièrement travaillé paie le salaire plein.
export const PAYROLL_DAY_DIVISOR = 22;
export const PAYROLL_FACTS = {
    absnj: { label: 'Absence non justifiée', deducted: true },
    absj: { label: 'Absence justifiée', deducted: true },
    maladie: { label: 'Maladie', deducted: true },
    entree: { label: 'Avant l’entrée', deducted: true },
    sortie: { label: 'Après la sortie', deducted: true },
    conge: { label: 'Congé', deducted: false },
    recup: { label: 'Récupération', deducted: false },
    tt: { label: 'Télétravail', deducted: false },
};
export const PAYROLL_FACT_KINDS = Object.keys(PAYROLL_FACTS);
export function payrollDailyRate(reference) {
    return reference / PAYROLL_DAY_DIVISOR;
}
/** Salaire du mois calculé : arrondi au dinar, jamais négatif. */
export function computeMonthSalary(reference, offDays) {
    return Math.max(0, Math.round(reference - payrollDailyRate(reference) * offDays));
}
//# sourceMappingURL=payroll.js.map